import useCompanionBalance from './useCompanionBalance';
import useEvilNoundleBalance from './useEvilNoundleBalance';
import useGenesisNoundleBalance from './useGenesisNoundleBalance';
import useStakedCompanions from './useStakedCompanions';
import useStakedEvilNoundles from './useStakedEvilNoundles';
import useStakedNoundles from './useStakedNoundles';
import useUnstakedCompanions from './useUnstakedCompanions';
import useUnstakedEvilNoundles from './useUnstakedEvilNoundles';
import useUnstakedNoundles from './useUnstakedNoundles';

const useTokenGate = (onlyWrapped) => {
  const genesisNoundleBalance = useGenesisNoundleBalance();
  const companionBalance = useCompanionBalance();
  const evilNoundleBalance = useEvilNoundleBalance();

  const stakedNoundles = useStakedNoundles();
  const unstakedNoundles = useUnstakedNoundles();

  const stakedCompanions = useStakedCompanions();
  const unstakedCompanions = useUnstakedCompanions();

  const stakedEvilNoundles = useStakedEvilNoundles();
  const unstakedEvilNoundles = useUnstakedEvilNoundles();

  const wrappedNoundleBalance = stakedNoundles.length + unstakedNoundles.length;
  const wrappedCompanionBalance =
    stakedCompanions.length + unstakedCompanions.length;
  const wrappedEvilNoundleBalance =
    stakedEvilNoundles.length + unstakedEvilNoundles.length;

  let tokenBalance =
    wrappedNoundleBalance + wrappedCompanionBalance + wrappedEvilNoundleBalance;

  if (!onlyWrapped) {
    tokenBalance += genesisNoundleBalance;
    tokenBalance += companionBalance;
    tokenBalance += evilNoundleBalance;
  }

  return tokenBalance > 0;
};

export default useTokenGate;
